import { Link, useLocation } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';

/** Banner only for online/ranked — never bot or local. */
export default function OnlineGameBanner() {
  const { userData } = useAuthContext();
  const { pathname } = useLocation();
  const onlineGameId = userData?.currentOnlineGameId;

  if (!onlineGameId) return null;
  if (pathname === `/play/${onlineGameId}`) return null;

  return (
    <div className="flex items-center justify-center gap-3 border-b border-bk-gold-dim/40 bg-bk-gold/10 px-4 py-2 text-sm">
      <span className="font-semibold uppercase tracking-wider text-bk-gold">
        You&apos;re in a match
      </span>
      <Link
        to={`/play/${onlineGameId}`}
        className="font-bold uppercase tracking-wide text-bk-gold-bright underline-offset-2 hover:underline"
      >
        Return to game
      </Link>
    </div>
  );
}
